import { Type } from 'class-transformer';
import { BaseResidentParameterDto } from './base-resident-parameter-dto';
import { AttachmentParameterDto } from './attachment-parameter-dto';

export class SubmitRequestParameterDto extends BaseResidentParameterDto {
  categoryId: number;
  notes: string;
  @Type(() => AttachmentParameterDto)
  requestAttachments: AttachmentParameterDto[];
}
